module.exports = __webpack_public_path__ + "static/media/banner_en.750cf380.jpg";